import moment from 'moment';

export const DateUtils = {
    formatPublishedDate: (date) => {
        return moment(date).local().format('MM/DD/YYYY hh:mm A');
    },
};
